import { useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import { getApiSetting, postApiSetting } from "../assets/functions";
import { ToastContainer, toast } from 'react-toastify';
import { useNavigate } from "react-router-dom";
import { TableStatusRow } from "../components/UI";
export default function ServiceManagement({setAuth}) {
 const navigate = useNavigate();
    const [serviceData, setServiceData] = useState([]);
    const [refreshTable, setRefreshTable] = useState(false);

    useEffect(() => {
        (async () => {
        // console.log('enter');
        // const Authorization = JSON.parse(sessionStorage.getItem('Authorization'))
            try {
                // let res = await fetch('/admin/api/Admin/Services/fetchServicesDetails', getApiSetting());
                let res = await fetch('/Admin/api/Admin/Services/fetchServicesDetails', getApiSetting());

                let result =(res.status === 200) ? await res.json(): "";
                // console.log(res)
                // console.log(result)
                if (res.status === 200) {
                    if(result.data.responseData.length > 0){
                        setServiceData(result.data.responseData)
                    }else{
                        setServiceData([])
                    }
                } else if(res.status === 401)
                { 
                    setAuth(false)
                    toast.error("Session Expired !", {position: 'top-center',});
                    navigate("/");                  
                    sessionStorage.clear();
                }
            } catch (error) {
                console.log(error)
            }
        })()
    }, [refreshTable])

    const onChangeStatus = async (e,id) => {
        let serviceStatus = '';
        if(e.target.checked){
            serviceStatus = 'UP';
        }else{
            serviceStatus = 'DOWN';
        }
        let settings = postApiSetting({id,serviceStatus})
        try {
            let res = await fetch('/Admin/api/Admin/Services/updateServicesDetails', settings);
            // let res = await fetch('admin/api/Admin/Services/updateServicesDetails', settings);
            let result = (res.status === 200) ? await res.json(): "";
            // console.log(result)
            if(res.status !== 200){
                if(res.status === 401)
                { 
                    setAuth(false)
                    toast.error("Session Expired !", {position: 'top-center',});
                    navigate("/");                  
                    sessionStorage.clear();
                }else{
                alert('something went wrong : ' + res.status)
            }
            }else{
                if(result.statusCode == 0){
                    alert('SUCCESS : '+result.status)   
                    setRefreshTable(refresh => !refresh)
                }else{
                    alert('FAILED : '+result.status)
                }
            }
        } catch (error) {
            console.log(error)
        }
    }

    return (<>
        {/* <SidebarNavigation /> */}
        <div className="dashboard-page w-100">
            <ToastContainer />
            <Navbar title="SERVICE MANAGEMENT" />
            <div className="container-fluid pe-3">
                <div className="main-content my-3">
                    <h6 className="mb-3">Service Management</h6>
                    <div className="table-responsive">
                        <table className="table table-bordered com-table">
                            <thead>
                                <tr>
                                    <th>S.no.</th>
                                    <th>Service</th>
                                    <th>Status (Action)</th>
                                </tr>
                            </thead>
                            <tbody>
                                {serviceData.length === 0 ? <TableStatusRow colSpan={3} status="Not Found" /> :
                                    serviceData.map((item, index) => {
                                        return (
                                            <tr key={item.id}>
                                                <td>{index + 1}</td>
                                                <td>{item.serviceName}</td>
                                                <td>
                                                    <div className="form-check form-switch">
                                                        <input className={`form-check-input shadow-none ${item.serviceStatus==='UP'?'bg-success':'bg-danger'}`} type="checkbox"
                                                        id={`sm_status_${item.id}`} onChange={(e)=>onChangeStatus(e,item.id)} defaultChecked={item.serviceStatus==='UP'?true:false } />
                                                        <label className='form-check-label' htmlFor={`sm_status_${item.id}`}>{item.serviceStatus}</label>
                                                    </div>
                                                </td>
                                            </tr>
                                        )
                                    })}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </>)
}